import { useState } from "react";

import Box from "@/components/Box";
import IconType from "@/components/IconType";
import RichText from "@/components/RichText";
import { SpanText } from "@/components/Text";
import { useOrganisationBasketContext } from "@/contexts/organisations/OrganisationBasketContext";
import { BLOOD_ICON_TYPE, COMING_SOON, SIMPLE_DNA_ICON_TYPE } from "@/core/constants";
import { GilroyFontCurrency } from "@/tpo/Currency";
import Group from "@/tpo/Group";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

export default function ReportAddOnDetail({
  status,
  icon,
  description,
  shortDescription,
  functionalDatapointCount,
  dnaDatapointCount,
  name,
  state,
  onRemove,
  onAdd,
  price,
  rrpPrice,
  text,
  showDescription,
  showMarkers
}) {
  const { loading, basket } = useOrganisationBasketContext();

  const [show, setShow] = useState(false);

  let bg = "white";
  let button = (
    <ButtonV2 color="green" onClick={onAdd} disabled={loading} type="button" size="sm">
      {text || "add"}
    </ButtonV2>
  );
  if (state === "unavailable") {
    bg = "#E5E5E5";
    button = (
      <ButtonV2
        color="midGrey"
        disabled
        sx={{
          opacity: 1
        }}
        type="button"
        size="sm"
      >
        {text || "add"}
      </ButtonV2>
    );
  } else if (state === "selected") {
    button = (
      <ButtonV2
        color="red"
        style={{
          lineHeight: "70%"
        }}
        onClick={onRemove}
        disabled={loading}
        type="button"
        size="sm"
      >
        remove
      </ButtonV2>
    );
  }

  return (
    <Stack bg={bg} p={20} borderRadius={20} gap={0}>
      {icon}
      <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]} lineHeight="28px" mt={16}>
        {name}
      </Box>
      {status !== COMING_SOON && (
        <Box fontFamily="gilroyMedium" fontSize={[12, 12, 14]} lineHeight="24px">
          {shortDescription}
        </Box>
      )}
      {showMarkers && (
        <Stack gap={8} mt={16}>
          <Box fontFamily="gilroyBold" fontSize={12}>
            Markers assessed
          </Box>
          <Group gap={16} mt="8px">
            <Group gap={8}>
              <IconType iconType={SIMPLE_DNA_ICON_TYPE} withCircle={false} iconSize={[20]} />
              <SpanText fontSize={12}>
                SNP&apos;s:
                <SpanText fontFamily="gilroyBold" ml="4px" fontSize={12}>
                  {dnaDatapointCount}
                </SpanText>
              </SpanText>
            </Group>
            <Group gap={8}>
              <IconType iconType={BLOOD_ICON_TYPE} withCircle={false} iconSize={20} />
              <SpanText fontSize={12}>
                Functional:
                <SpanText fontFamily="gilroyBold" ml="4px" fontSize={12}>
                  {functionalDatapointCount}
                </SpanText>
              </SpanText>
            </Group>
          </Group>
        </Stack>
      )}
      {status !== COMING_SOON ? (
        <Group
          alignItems="center"
          gap={10}
          bg="haze"
          py="12px"
          px={20}
          borderRadius={12}
          mt={28}
          justifyContent="space-between"
        >
          <Stack gap={8}>
            <GilroyFontCurrency
              value={price}
              color="dark"
              symbol={basket?.currencySymbol}
              fontSize={24}
            />
            <GilroyFontCurrency
              value={rrpPrice}
              symbol={basket?.currencySymbol}
              fontSize={14}
              decimalFontSize={14}
              prefix="RRP"
              color="midGrey"
            />
          </Stack>

          {button}
        </Group>
      ) : (
        <Group justifyContent="flex-end">{button}</Group>
      )}
      {status !== COMING_SOON && (
        <ButtonV2
          variant="transparent"
          chevronProps={{
            direction: show ? "top" : "bottom",
            fill: "black"
          }}
          withChevron
          onClick={() => setShow(!show)}
          p={0}
          size={null}
          sx={{
            fontFamily: "gilroyBold",
            fontSize: 10,
            mt: "20px",
            ml: "auto"
          }}
          type="button"
        >
          details
        </ButtonV2>
      )}
      {show && (
        <RichText fontFamily="gilroyMedium" fontSize={[14, 14, 16]} px={40} py={20}>
          {description}
        </RichText>
      )}
    </Stack>
  );
}
